import { useCallback, useMemo } from 'react';
import { ComponentType, DataType } from '@vgtv/api-client/lib/component';
import { useTranslation } from 'react-i18next';

import { useVendor } from '../../components/VendorPovider/VendorPovider';
import { AssetSplash } from '../../components/Splash/AssetSplash/AssetSplash';
import { usePlayerContext } from '../../player/PlayerContext';

import type { MouseEventHandler, VFC } from 'react';
import type { AssetSplashComponent } from '@vgtv/api-client/lib/component/splash';
import type { ComponentId } from '@vgtv/api-client/lib/component';
import type { SvpAssetAdditional } from '@vgtv/api-client/lib/svp_asset';
import type { Provider } from '@vgtv/api-client';

type Props = {
  asset: SvpAssetAdditional;
  startTime?: number;
};

export const AssetSmartSplash: VFC<Props> = ({ asset, startTime }) => {
  const { t } = useTranslation();
  const { startPlayback } = usePlayerContext();
  const { vendor } = useVendor();

  const componentConfig: AssetSplashComponent<true> = useMemo(() => {
    const date = new Date().toISOString();
    return {
      id: String(asset.id) as ComponentId,
      type: ComponentType.SPLASH,
      provider: vendor as Provider,
      createdAt: date,
      updatedAt: date,
      updatedBy: '',
      isShared: false,
      options: {
        buttonLabel: t('Click to watch'),
      },
      data: {
        type: DataType.ASSETS,
        preset: [asset],
      },
    };
  }, [t, vendor, asset]);

  const handleButtonClick: MouseEventHandler = useCallback(
    (event) => {
      startPlayback({ forceAsset: asset, startTime });
      event.preventDefault();
    },
    [startPlayback, asset, startTime]
  );

  return (
    <AssetSplash
      componentConfig={componentConfig}
      isFirstComponent
      pageComponentIndex={0}
      overridePlayButtonClick={handleButtonClick}
    />
  );
};
